<template>
  <section>
    <div :class="$style.roadmap__list">
      <div
        v-for="course in courses"
        :key="course.id"
        :class="$style.roadmap__item"
      >
      <router-link :to="courseUrl(course)" :class="$style.roadmap__item__content">
        <div :class="[$style.roadmap__item__img]">
          <img :src="course.thumb" />
        </div>
        <BaseProgressBar :value="course.attended_percent"/>
      </router-link>

        <span :class="[$style.roadmap__statusBox, (course.is_certificate_available ? $style.roadmap__statusBox__active : '')]">
          <img  
            v-if="course.is_certificate_available"
            src="@/assets/img/trail/trail-check.png"
          />
          <img
            v-else
            src="@/assets/img/trail/trail-study.png"
          />
        </span>
      </div>
    </div>
  </section>
</template>

<script>
import BaseProgressBar from '@/components/progressbar/BaseProgressBar'
import { mapGetters } from 'vuex';

export default {
  name: 'TrailRoadmap',

  props: {
    courses: { type: Array, required: true },
  },

  components: {
    BaseProgressBar,
  },

  computed: {
    ...mapGetters('course', ['courseUrl']),
  }
}
</script>

<style module lang="scss">
@import "~@/components/trail/trail.scss";
.roadmap__list {
  position: relative;
  max-width: 670px;
  margin: auto;
  display: flex;
  flex-direction: column;

  &:after {
    content: '';
    position: absolute;
    border-right: 2px dashed #fff;
    height: 93.5%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}

.roadmap__item {
  --statusBoxSize: 40px;
  --statusBoxShadowSize: 4px;
  --statusBoxSpacingSize: 26px;
  --progressBarGap: 22px;

  display: inline-flex;
  width: 100%;
  width: calc(50% + var(--statusBoxSize) / 2 + var(--statusBoxSpacingSize));
  align-items: center;
  justify-content: flex-start;
  flex: 0 0 auto;

  &__content {
    display: inline-block;
    position: relative;
  }

  &:nth-child(even) {
    flex-direction: row-reverse;
    align-self: self-end;
  }

  @media (max-width: 992px) {
    --statusBoxSize: 24px;
    --statusBoxShadowSize: 0px;
    --statusBoxSpacingSize: 8px; 
  }
}

.roadmap__item__img {
  position: relative;
  margin-bottom: 8px;
  
  img {
    max-width: 100%;
    width: auto;
    border-radius: 8px;
  }
}

.roadmap__statusBox {
  z-index: 3;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: var(--statusBoxSize);
  height: var(--statusBoxSize);
  border-radius: 100%;
  background-color: #fff;
  box-shadow: 0 0 0 var(--statusBoxShadowSize) rgba(#fff, .2), 0 0 0 calc(var(--statusBoxShadowSize) * 2 + 2.5px) $trail-bg-color;
  flex-shrink: 0;
  margin: 0 var(--statusBoxSpacingSize);
  transform: translateY(calc(var(--progressBarGap) / 2 * -1));

  &__active {
    background-color: #20BF56;
    box-shadow: 0 0 0 var(--statusBoxShadowSize) rgba(#20bf56, .2), 0 0 0 calc(var(--statusBoxShadowSize) * 2 + 2.5px) $trail-bg-color;
  }
  
  img {
    max-width: 70%;
  }
}
</style>